import React from 'react';
import styled from 'styled-components';
import {
  AccountBalanceWalletOutlined,
  CopyrightOutlined,
  BlockOutlined,
  CancelOutlined,
  ReportOutlined,
  GavelOutlined,
  SyncOutlined,
  EmailOutlined
} from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
  font-family: '"Proxima Nova"', sans-serif;
  line-height: 1.6;
`;

const Heading = styled.h1`
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const Section = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
`;

const IconWrapper = styled.div`
  margin-right: 25px;
  color: #007bff;
  margin-top: -5px; /* Align icon better with text */
`;

const SectionContent = styled.div`
  flex: 1;
`;

const SectionTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 10px;
`;

const Terms = () => {
  return (
    <PageContainer>
      <Heading>Terms of Service</Heading>
      <p><strong>Last updated:</strong> June 10, 2025</p>

      <p>
        Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the DevOps Buddy dashboard (the "Service") operated by Vaidhyamegha Pvt. Ltd. ("us", "we", or "our").
      </p>
      <p>
        Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service.
      </p>

      <Section>
        <IconWrapper><AccountBalanceWalletOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Accounts</SectionTitle>
          <p>When you create an account with us, you must provide us with information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><CopyrightOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Intellectual Property</SectionTitle>
          <p>The Service and its original content, features, and functionality are and will remain the exclusive property of Vaidhyamegha Pvt. Ltd. and its licensors.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><BlockOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Prohibited Uses</SectionTitle>
          <p>You agree not to use the Service:</p>
          <ul>
            <li>In any way that violates any applicable national or international law or regulation.</li>
            <li>To engage in any conduct that restricts or inhibits anyone's use or enjoyment of the Service.</li>
            <li>To attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Service.</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><CancelOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Termination</SectionTitle>
          <p>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><ReportOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Limitation of Liability</SectionTitle>
          <p>In no event shall Vaidhyamegha Pvt. Ltd., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><GavelOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Governing Law</SectionTitle>
          <p>These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><SyncOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Changes</SectionTitle>
          <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will try to provide at least 30 days' notice prior to any new terms taking effect.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><EmailOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Contact Us</SectionTitle>
          <p>If you have any questions about these Terms, please contact us at <a href="mailto:support@vaidhyamegha.com">support@vaidhyamegha.com</a>.</p>
        </SectionContent>
      </Section>
    </PageContainer>
  );
};

export default Terms;
